import { useNavigate, Navigate } from "react-router-dom";
import React, { useContext, useEffect } from "react";
import { AuthContext } from "../providers/AuthProvider";
import { NavigationService } from "../utils/NavigationService";
import MaijaLoadingPage from "./MaijaLoadingPage";
import AppShell from "./AppShell";
import MaijaRoute, { LOGIN_ROUTE } from "../Routes";
import { SecurityLevel } from "../types/User";

type ProtectedRouteProps = {
  route: MaijaRoute;
  children: React.ReactNode;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ route, children }) => {
  const { user, loading: authLoading } = useContext(AuthContext);
  const navigate = useNavigate();

  // Set up navigation service for use in non-React contexts (like Axios interceptors)
  useEffect(() => {
    NavigationService.setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    if (!authLoading && !user) {
      navigate(LOGIN_ROUTE.path, { replace: true });
    }
  }, [authLoading, user, navigate]);

  if (authLoading) {
    return <MaijaLoadingPage isFullscreen />;
  }

  if (!user) {
    return null;
  }

  // Back office requires the platform-admin tier for every route.
  if (user.securityLevel < (route.securityLevel ?? SecurityLevel.PlatformAdmin)) {
    return <Navigate to={LOGIN_ROUTE.path} replace />;
  }

  return <AppShell>{children}</AppShell>;
};

export default ProtectedRoute;
